import { useContext, useEffect, useState } from 'react';
import AppSettingsService from '../../services/app-settings.service';
import useUserActivity from '../../services/use-user-activity';
// import DarkLogo from '../../styles/images/dark-logo.svg';
import SessionContext from '../Core/SessionContext';
import CardBottom from '../../features/alumni/alumni-directory/CardBottom';
import { getStudentImage } from '../../common/styles/Images';
import { SmartContext } from '../Core/SmartContext';
import { axiosClient } from '../Service/axiosClient';
import { useNavigate } from 'react-router-dom';
import smartReducer from '../Core/SmartReducer';
import { useImmerReducer } from 'use-immer';
import { DispatchEvent, State } from '../Core/SmartTypes';
import { getLoginMode, isEmpty, isSchoolAdmin, isSuperAdmin } from '../Core/SmartFunctions';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'bootstrap';
import Swal from 'sweetalert2';
import { GlobalContext } from '../Core/GlobalContext';

const DarkLogo = `${process.env.REACT_APP_IMAGE_BASEPATH}/dark-logo.svg`;


const PageFooterControl = () => {
    const location = useLocation();
    const { sessionState } = useContext(SessionContext);
    const loginMode = getLoginMode(); // @UAS-2071
    const id = sessionState?.id;
    const instituteGroupId =sessionState?.instituteGroupId
    const [isFooterModalOpen, setFooterModalOpen] = useState(false);
    // const { state, dispatch } = useContext(SmartContext);
    const navigate = useNavigate();
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        data: { filters: {} },
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { ROUTER_NAVIGATE: navigate },
    } as any);
    const { globalDispatch } = useContext(GlobalContext);

    const handleInactivity = () => {
        console.log('User is inactive!');
        sessionStorage.clear();
        sessionStorage.setItem('user-logged-out', 'TRUE');
        // localStorage.setItem('user-logged-out', 'TRUE');
        // navigate('/login'); // redirect to login or any other action you want
        // window.location.href = AppSettingsService.getLoginUrlFromStorage() as string;
        window.location.href = AppSettingsService.getLoginUrl(sessionState) as string;
    };

    useUserActivity(300 * 60 * 1000, handleInactivity);
    
    //   if(sessionState?.userTypeCode === 'STUDENT'){
    interface MatchAlum {
        uuid : string;
        name : string;
        programName : string;
        passOutYear : number;
    }

    const handleSendMessage = (event: any, id: string) => {
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/${id}`);
    };

    const handleSendMessageMultiple = (event: any, uiid: any) => {
        // var uiid = uiid.join('/');
        updateNextBatchAlumni();
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/${uiid}`);
        setFooterModalOpen(false);
    };

    const updateNextBatchAlumni = async () => {
        const studentId = sessionState?.studentId;
        try {
            const response = await axiosClient().get(`${process.env.REACT_APP_REPORTS_SERVER}/common/update-next-alumni-batch/${studentId}`);
        } catch (error) {
            console.log(error);
        }
    };

    const [topAlumni, setmatchAlum] = useState<MatchAlum[] | null>(null);
    const [multipleUiid, setmultipleUiid] = useState<string>(''); 
    
    const fetchTopAlumni = async () => {
        try {
            openFooterModal();
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const fetchTopAlumni = async () => {
            try {
                const studentId = sessionState?.studentId ?? sessionState?.id;
                const instituteGroupId = sessionState?.instituteGroupId;
                if (!studentId || !instituteGroupId) return;
                const response = await axiosClient().get(
                    `${process.env.REACT_APP_REPORTS_SERVER}/common/alumni-top-match/${studentId}/${instituteGroupId}`
                );
                setmatchAlum(response.data.fetchedAlumni);
            } catch (error) {
                console.error('Error fetching topAlumni:', error);
            }
        };

        // Was `||`, which negates to isSchoolAdmin() && isSuperAdmin() — never both
        // true for one user, so the guard never actually blocked admin/management.
        if (!isSchoolAdmin() || !isSuperAdmin()) {
            fetchTopAlumni();
        }
    }, [id, instituteGroupId]);

    const openFooterModal = () => {
        setFooterModalOpen(true);
    };
    
    const closeFooterModal = () => {
        setFooterModalOpen(false);
    };
    
    useEffect(() => {
        if (topAlumni && topAlumni.length > 0) {
            const uuids = topAlumni.map((alum: any) => alum.uuid).join('/');
            setmultipleUiid(uuids);
        }
    }, [topAlumni]); // This useEffect triggers whenever topAlumni is updated

    // console.log("topAlumni",topAlumni)
    const studentProfileLink = (uuid: string) => {
        const link = `/alumni/${uuid}/profile`;
        return link;
    };
    
    /**
     * @UAS-2071
     * @returns Contirmation prompt to restore session;
     * @by RG
     */
    const goBackToMainUserSession = () => {
        return () => {
            Swal.fire({
                title: 'Exit Impersonation?',
                text: 'You’ll be logged out of the impersonated session and returned to your account.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Proceed!',
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Restoring your session...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    restoreMainUserSession();
                }
            });
        };
    }

    /**
     * @UAS-2071 @by RG
     * Restores the main user session from impersonation;
     */
    const restoreMainUserSession = () => {
        localStorage.setItem('user', localStorage.getItem('user-main') || '');
        // localStorage.setItem('token', localStorage.getItem('token-main') || '');
        localStorage.setItem('user-jwt-token', localStorage.getItem('token-main') || '');
        localStorage.setItem('univariety-user', localStorage.getItem('univariety-user-main') || '');
        sessionStorage.setItem('user', localStorage.getItem('user-main') || '');
        sessionStorage.setItem('user-jwt-token', localStorage.getItem('token-main') || '');

        localStorage.removeItem('user-main');
        localStorage.removeItem('token-main');
        localStorage.removeItem('univariety-user-main');
        
        // Store toast data in localStorage to display after page reload
        localStorage.setItem('pendingToastData', JSON.stringify({ message: "Your session has been restored successfully!" }));
        
        const redirectUrl = localStorage.getItem('url-main');
        if (redirectUrl) {
            localStorage.removeItem('url-main');
            sessionStorage.setItem('active-tab', 'TRUE');
            
            // Send message to redirect curent tab and close others
            const channel = new BroadcastChannel('auth');
            channel.postMessage({ 
                type: 'REDIRECT_CLOSE_TAB', 
                path: redirectUrl
            });
            channel.close();
        }
    }

    // Check for persisted toast data and dispatch it
    useEffect(() => {
        const pendingToast = localStorage.getItem('pendingToastData');
        if (pendingToast) {
            try {
                const toastData = JSON.parse(pendingToast);
                globalDispatch({ type: 'SET_TOAST_DATA', payload: toastData });
                localStorage.removeItem('pendingToastData');
            } catch (error) {
                console.error('Error parsing persisted toast data:', error);
            }
        }
    }, [globalDispatch]);

    useEffect(() => {
        const els: Element[] = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"].html-tooltip'));
        const tooltipList = els.map((el) => {
            const rawTitle = el.getAttribute('data-bs-title') ?? el.getAttribute('title');
            if (!rawTitle || rawTitle.trim() === '' || rawTitle === 'null') return null;
            try {
                return new Tooltip(el as HTMLElement, {
                    title: rawTitle,
                    trigger: 'hover',
                    html: true,
                    customClass: 'tooltip-html',
                    container: 'body',
                    delay: { show: 0, hide: 100 }
                });
            } catch (e) {
                console.error('Tooltip init error', e);
                return null;
            }
        }).filter(Boolean) as Tooltip[];

        return () => {
            tooltipList.forEach((tooltip) => {
                if (tooltip && typeof tooltip.dispose === 'function') {
                    tooltip.dispose();
                }
            });
        };
    }, [topAlumni]);

    useEffect(() => {
        const els: Element[] = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"].smart-tooltip'));
        const tooltipList = els.map((el) => {
            const rawTitle = el.getAttribute('data-bs-title') ?? el.getAttribute('title');
            if (!rawTitle || rawTitle.trim() === '' || rawTitle === 'null') return null;
            try {
                return new Tooltip(el as HTMLElement, {
                    title: rawTitle,
                    trigger: 'hover',
                    container: 'body',
                    delay: { show: 0, hide: 100 }
                });
            } catch (e) {
                console.error('Tooltip init error', e);
                return null;
            }
        }).filter(Boolean) as Tooltip[];

        return () => {
            tooltipList.forEach((tooltip) => {
                if (tooltip && typeof tooltip.dispose === 'function') {
                    tooltip.dispose();
                }
            });
        };
    }, [topAlumni]);

    // useEffect(() => {
        // const tooltipTriggerList = [].slice.call(document.querySelectorAll('.impersonate-action-disabled'));
        // const tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
        // return new Tooltip(tooltipTriggerEl, {
        //     title: "You can't perform this action in impersonation mode", // Tooltip title
        //     trigger: 'hover',
        //     html: true,
        //     customClass: 'tooltip-html',
        //     container: 'body',
        //     delay: { show: 0, hide: 100 },
        // });
        // });

        // return () => {
        // // Cleanup tooltips when the component unmounts
        // tooltipList.forEach(tooltip => tooltip.dispose());
        // };
        // initializeImpersonateTooltips();
    // }, [topAlumni]);

    return (
        <>
            <footer className="footer">
                {loginMode === 'LIMITED_ACCESS' && ( // @UAS-2071
                    <div className="impersonate-login position-fixed bottom-20 left-20 z9 p-3 bg-white border rounded-pill shadow-sm d-flex align-items-center justify-content-center html-tooltip" data-bs-toggle="tooltip" data-bs-html="true" title={`<div class="d-flex flex-column align-items-start"><span class="font-14 font-400">You are logged in as:</span><span class="font-16 font-500">${sessionState?.firstName} ${sessionState?.lastName}</span><span class="font-12">Click to exit impersonation!</span></div>`}>
                        <i className="bi bi-box-arrow-left font-22 text-danger cursor-pointer" onClick={goBackToMainUserSession()}></i>
                    </div>
                )}
                <div className="footer-wrap">
                    <div className="row align-items-center">
                        <div className="col-sm">
                            <div className="copyRight">
                                {/* International Educational Gateway Pvt. Ltd. © 2023. All Rights Reserved. Univariety */}
                                International Educational Gateway Pvt. Ltd. © {new Date().getFullYear()}. All Rights Reserved. Univariety
                            </div>
                        </div>
                        <div className="col-sm-auto">
                            <div className="powerby">
                                <span>Powered By</span>
                                <img src={DarkLogo} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <div>
                {sessionState?.userTypeCode === 'STUDENT' && (
                    <>
                        {!isEmpty(topAlumni) && !location.pathname.includes('directory') &&  (
                            <a href="javascript:;" className="btn-alumni-guidance" onClick={() => openFooterModal()} >
                               <i></i> <span>ALUMNI GUIDANCE</span>
                            </a>
                        )}
                        <div
                            className={`modal fade show vh-100  ${isFooterModalOpen ? 'show' : ''}`}
                            id="alumni-guidance"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabelvideo"
                            aria-hidden="true" 
                            style={{ display: isFooterModalOpen ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered max-1140" role="document">
                                <div className="modal-content radius-6">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Chat With The Alumni For Guidance Now</h5>
                                        <button
                                            type="button"
                                            className="btn-close m-1 position-absolute right20 top20 z9"
                                            onClick={() => closeFooterModal()}></button>
                                    </div>

                                    <div className="modal-body p-4 text-capitalize">
                                    <div className="row g-2 g-md-4 alumni-showcase">
    
    {topAlumni && topAlumni.length > 0 ? (
        <>
            {topAlumni.map((alum) => (
                <div className="col-lg-4 col-md-6 col-sm-6" key={alum.uuid}>
                    <div className="alumni-bucket">
                        <div className="alumni_class_link">
                            <div className="alumni_name_detail">
                                <div className="alumni_img">
                                 <a
                                        className="alumni_img_link"
                                        target="_blank"
                                        href={studentProfileLink(alum.uuid)}
                                        rel="noreferrer">
                                        <img
                                            className="img-fluid"
                                            src={getStudentImage(alum)}
                                            alt={`${alum.name}`}
                                      />
                                    </a>
                                </div>
                                <div className="alumni_name_brife">
                                    <h3>
                                        <a className="alumni_name_link" href="javascript:;">
                                            {alum.name}                                       </a>
                                    </h3>
                                    <span className="alumni_campus">
                                        {alum?.programName}, {alum?.passOutYear}
                                    </span>
                                </div>
                            </div>
                            <div className="send_link">
                                <a
                                    role="button"
                                    onClick={(event) => handleSendMessage(event, alum.uuid)}
                                    className="btn-send">
                                    <i className="icon-alumni-send"></i>
                                    <span>Send</span>
                                </a>
                            </div>
                        </div>
                        <CardBottom alumni={alum} state={state} />
                    </div>
                </div>
            ))}
            <div className="col-12 text-center d-flex justify-content-center">
                <button className="btn btn-green">
                    <span onClick={(event) => handleSendMessageMultiple(event, multipleUiid)}>
                        Send to All
                    </span>
                    <i className="icon-alumni-send ms-2 position-relative"></i>
                </button>
            </div>
        </>
    ) : (
        <div className="col-12 text-center">
            <p>No data available</p>
        </div>
    )}
                                     
                                     </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default PageFooterControl;
